import { DocumentType } from "../hooks/useDocumentTypes";

// Quita puntos y espacios que el usuario suele escribir (900.123.456-7);
// el guion del NIT se conserva porque separa la base del dígito verificador.
export const normalizeDocumentNumber = (value: string): string =>
  value.trim().replace(/[.\s]/g, "").toUpperCase();

export const isValidDocumentNumber = (
  type: DocumentType | undefined,
  value: string
): boolean => {
  if (!type || value === "") return false;

  const min = type.minimumValidation ?? 5;
  const max = type.validation ?? 20;

  if (type.digitVerification) {
    const match = /^(\d+)-(\d)$/.exec(value);
    if (!match) return false;
    const [, base] = match;
    if (base.length < min || base.length > max) return false;
    if (base.startsWith("0")) return false;
    return true;
  }

  if (value.length < min || value.length > max) return false;

  return type.validationDataType === "text"
    ? /^[A-Z0-9]+$/.test(value)
    : /^[1-9]\d*$/.test(value);
};
